const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

const STATUS_URL = 'https://status.thallein.com/status/guioncreator'

const TRUST_ITEMS = [
  {
    label: 'Cancelación',
    value: '1 click. Sin laberinto.',
  },
  {
    label: 'Status público',
    value: '100% uptime',
    href: STATUS_URL,
    external: true,
  },
  {
    label: 'Si falla, no pagas',
    value: 'Crédito devuelto automático',
  },
  {
    label: 'API key propia',
    value: 'Cifrada con Fernet (BYOK)',
  },
  {
    label: 'Hecho en',
    value: 'España',
  },
]

export function TrustStrip() {
  return (
    <section className="py-16 border-b border-ds-border">
      <div className={cx}>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-[1px] bg-ds-border-mid border border-ds-border-mid">
          {TRUST_ITEMS.map(({ label, value, href, external }) => {
            const content = (
              <>
                <p className="font-display font-bold text-label tracking-caption uppercase text-ds-muted mb-2">
                  {label}
                </p>
                <p className="font-display font-extrabold text-[14px] tracking-[0.02em] text-ds-text leading-[1.3]">
                  {value}
                </p>
              </>
            )
            return (
              <div key={label} className="bg-ds-bg p-5 sm:p-6 flex flex-col justify-center">
                {href ? (
                  <a
                    href={href}
                    target={external ? '_blank' : undefined}
                    rel={external ? 'noopener noreferrer' : undefined}
                    className="block no-underline hover:opacity-80 transition-opacity duration-150"
                  >
                    {content}
                    <span className="inline-block mt-2 font-display font-bold text-[10px] tracking-[0.1em] uppercase text-ds-red">
                      Ver en vivo →
                    </span>
                  </a>
                ) : (
                  content
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
